var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c("div", [_vm._v("Loading Please wait...")])
    : _vm.list.length === 0
    ? _c("div", [_c("span", [_vm._v("No Inspection types specified.")])])
    : _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          attrs: {
            id: "inspection-types-table",
            data: _vm.list,
            fit: "",
            size: "small",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              width: "120px",
              "min-width": "120px",
              align: "left",
              label: "Inspection Type",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.inspTypeName) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "min-width": "240px",
              align: "left",
              label: "Description",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.inspTypeDescription) + " ")]
                },
              },
            ]),
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }